export default "__VITE_ASSET__K0Z3I_PX__"